import _ from 'lodash'
String.prototype.hashCode = function () {
	let hash = 5381,
		i = this.length
	while (i) hash = (hash * 33) ^ this.charCodeAt(--i)
	return hash >>> 0
}

String.prototype.capitalize = function () {
	return _.capitalize(this)
}

String.prototype.lowercaseFirstLetter = function () {
	return this.charAt(0).toLowerCase() + this.slice(1)
}
